<template>
    <div class="flex product-card" :class="{'out-of-stock' : !item.in_stock}">
        <div class="image-section">
            <img
                :src="item.images.length ? item.images[0].image.original : defaultImage"
                alt="image"
            />
        </div>

        <div class="content flex">
            <div class="flex">
                <div class="name__price">
                    <p class="--font --weight">
                        {{ item.product_name }}
                    </p>
                    <p class="secondary-font">
                        {{ item.product_size }} {{ item.measuring_unit ? item.measuring_unit.name : '' }}
                    </p>
                </div>

                <div
                    class="sold__value flex"
                    style="align-items: flex-start"
                >
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="#D0D0D0"
                                class="pointer"
                                v-bind="attrs"
                                v-on="on"
                                style="margin-right : -10px"
                                >mdi-dots-vertical
                            </v-icon
                            >
                        </template>
                        <v-list>
                            <v-list-item
                                @click="seleteItem(item.id, i.action)"
                                v-for="i in dropdownItems"
                                :key="i.id"
                                link
                            >
                                <v-list-item-title>{{
                                    i.title
                                }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>

            <div class="flex">
                <p class="price --green" v-if="item.selling_price">₹{{ item.selling_price }}</p>
                <p
                    @click="$emit('editProduct', {ID : item.id, type : 'editPrice'});"
                    v-if="item.discount_percentage"
                    class="discount --green pointer --weight"
                >
                    {{ item.discount_percentage }}% discount
                </p>
                <p
                    @click="$emit('editProduct', {ID : item.id, type : 'editPrice'});"
                    v-else-if="!item.selling_price"
                    class="discount --green pointer --weight"
                >
                    Add Your price
                </p>
                <p
                    @click="$emit('editProduct', {ID : item.id, type : 'editPrice'});"
                    v-else
                    class="discount --blue pointer --weight"
                >
                    Offer discount
                </p>
                <div>
                    <small>Lead count</small>
                    <p>{{ item.lead_count }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import accessToken from '../../../../helpers/accessToken';
import API_URL from "../../../../helpers/apiUrls"
export default {
    name: "productCard",

    props: {
        item: {
            type: Object,
        },
    },

    data() {
        return {
            defaultImage : require("../../../../assets/MainDashboard/Products/DefaultImage.png")
        };
    },

    computed : {
        dropdownItems() {
            const items = [
                {
                    id: 0,
                    title: "View Product",
                    action: "view",
                },
                {
                    id: 1,
                    title: "Edit",
                    action: "edit",
                },
                {
                    id: 2,
                    title: "Edit Price",
                    action: "edit_price",
                },
                {
                    id: 3,
                    title: "Remove",
                    action: "remove",
                },
            ]

            if(this.item.is_global) {
                items.push(
                    {
                        id: 6,
                        title: "Make Local",
                        action: "make_local",
                    },
                )
            }
            else {
                items.push(
                    {
                        id: 5,
                        title: "Make Global",
                        action: "make_global",
                    },
                )
            }

            if(this.item.in_stock) {
                items.push(
                    {
                        id: 4,
                        title: "Make Out of Stock",
                        action: "make_inactive",
                    },
                )
            }
            else {
                items.push(
                    {
                        id: 7,
                        title: "Make In-Stock",
                        action: "make_in_stock",
                    },
                )
            }

            return items;
        }
    },

    methods: {
        seleteItem(id, type) {
            let data = {}
            let confirmData = {}
            switch (type) {
                case "edit":
                    this.$emit('editProduct', {ID : id, type : 'editProduct'});
                    break;

                case "edit_price":
                    this.$emit('editProduct', {ID : id, type : 'editPrice'});
                    break;

                case "remove":
                    confirmData = {
                        content : "Are you sure you want to remove this product?",
                        action : () => this.deleteProduct(id)
                    }
                    this.$store.commit("mainStore/SET_CONFIRMATION_DIALOG", confirmData);
                    break;

                case "make_inactive":
                    data = {
                        in_stock : false
                    }

                    confirmData = {
                        content : "Are you sure you want to make this product out of stock?",
                        action : () => this.editProductPartially(data, id)
                    }
                    this.$store.commit("mainStore/SET_CONFIRMATION_DIALOG", confirmData);
                    break;

                case "make_in_stock":
                    data = {
                        in_stock : true
                    }
                    this.editProductPartially(data, id);
                    break;

                case "make_global":
                    data = {
                        is_global : true
                    }
                    confirmData = {
                        content : "Are you sure you want to make this product global?",
                        action : () => this.editProductPartially(data, id)
                    }
                    this.$store.commit("mainStore/SET_CONFIRMATION_DIALOG", confirmData);
                    break;

                case "make_local":
                    data = {
                        is_global : false
                    }
                    confirmData = {
                        content : "Are you sure you want to make this product local?",
                        action : () => this.editProductPartially(data, id)
                    }
                    this.$store.commit("mainStore/SET_CONFIRMATION_DIALOG", confirmData);
                    break;

                case "view":
                    this.$emit('view', {ID : id, type : 'view'});
                    break;

                default:
                    break;
            }
        },

        editProductPartially(data, ID) {
            const successHandler = response => {
                if(response.status === 200) {
                    this.$emit('refresh');
                }
            }

            const errorHandler = error => {
                this.showToast('Something went wrong internally!', "error", 10000)
                console.log(error);
            }

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}` 
            }

            this.requestPATCH(
                `${API_URL.products__historicalProducts}/${ID}`,
                data,
                headers,
                successHandler,
                errorHandler
            )
        },

        deleteProduct(ID) {
            const successHandler = response => {
                this.$emit('refresh');
            }

            const errorHandler = error => {
                this.showToast('Something went wrong internally!', "error", 10000)
                console.log(error);
            }

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}` 
            }

            this.requestDELETE(
                `${API_URL.products__historicalProducts}/${ID}`,
                {},
                headers,
                successHandler,
                errorHandler
            )
        }
    },
};
</script>

<style lang="scss" scoped>
.product-card {
	background-color: white;
	padding: 10px;
	box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
	border-radius: 5px;

	p {
		margin: 0;
	}

    &.out-of-stock {
        opacity: 0.6;
    }
}

.product-card > div:nth-child(1) {
	justify-content: space-between;
	align-items: flex-start;
	height: 100%;
}

.image-section {
	width: 20%;
	margin-right: 10px;
	height: 100%;
    border: 1px solid rgb(235, 229, 229);
}

.image-section img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

small {
	color: #a6aca9;
}

.content {
	width: 80%;
	height: 100%;
	flex-direction: column;
	justify-content: space-between;
	align-items: unset;
}

.content > div:nth-child(1) {
	align-items: flex-start;
	justify-content: space-between;
}

.content > div:nth-child(2) {
	justify-content: space-between;
	align-items: flex-end;
	flex-wrap: wrap;
}

.price {
	font-size: 1.1rem;
}

.discount {
	font-size: 0.6rem;
	background: #f4faf7;
	border-radius: 3px;
	padding: 5px;
}

@media all and (min-width: 1400px) {
	.price {
		font-size: 1.3rem;
	}

	.discount {
		font-size: 0.8rem;
		padding: 7px 10px;
	}
}
</style>
